import { useIsSignedMsgUserOrdersAccountInitialized } from 'src/hooks/signedMsgOrders/useIsSignedMsgUserOrdersAccountInitialized';
import useCurrentSettings from 'src/hooks/useCurrentSettings';

/**
 * Determines if Swift is enabled at the global level for this user.
 * If the user has not explicitly configured Swift in their settings,
 * it defers to their account init status.
 *
 * Note, will return `undefined` if the user's account does not yet exist.
 */
export default function useIsSwiftEnabledForUser() {
	const [{ swiftEnabled: isSwiftEnabledInSettings }] = useCurrentSettings();

	// This can actually be `undefined` if the query is disabled due to the
	// user not yet having an account.
	const { data: isSignedMsgUserOrdersAccountInitialized, isLoading } =
		useIsSignedMsgUserOrdersAccountInitialized();

	if (isLoading || isSignedMsgUserOrdersAccountInitialized === undefined) {
		return;
	}

	if (isSwiftEnabledInSettings === undefined) {
		return isSignedMsgUserOrdersAccountInitialized;
	}

	// If a user has explicitly turned on Swift in their settings, then their
	// account should also already be initialized, but just adding this extra
	// check to be on the safe side.
	return isSwiftEnabledInSettings && isSignedMsgUserOrdersAccountInitialized;
}
